import gohhanleong from "../Assets/gohhanleong.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img
          className="card-img-style"
          src={gohhanleong}
          alt="judge picture"
        ></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Goh Han Leong</h2>
        <br />
        <p className="card-sub-name-style">
          {" "}
          Senior Principal Specialist, Platform Services Data aNalytics & AI
          (DnA), Synapxe
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />

            <h2>Goh Han Leong</h2>
            <br />

            <h3>
              Senior Principal Specialist, Platform Services Data aNalytics & AI
              (DnA) Synapxe
            </h3>
            <br />
            <p>
              Dr. Goh Han Leong is the Senior Principal Specialist at Synapxe,
              Singapore’s national HealthTech agency, where he leads the
              development of AI and data analytics solutions to enhance
              healthcare management and outcomes. He guides stakeholders on
              advancing AI adoption in healthcare and has led impactful
              projects, including using machine learning to predict hospital
              readmissions and applying deep learning on chest X-rays to detect
              severe pneumonia and COVID-19 infections. For his contributions
              during the pandemic, he received the National Commendation Medal
              (COVID-19) in 2022.
              <br />
              <br />
              With over 15 years of experience, Dr. Goh is an accomplished data
              scientist and Adjunct Senior Lecturer at the National University
              of Singapore, where he teaches “Healthcare Transformation with
              Analytics” in the Master of Science in Business Analytics
              programme.
              <br />
              <br />
              Previously, he worked at Singtel’s Living Analytics R&D Lab,
              applying big data insights to client projects, and at the Land
              Transport Authority, providing technology leadership for mobility
              solutions. Beyond his professional roles, Dr. Goh contributes to
              shaping industry standards as a member of the Singapore Standards
              Council’s Technical Committee on Artificial Intelligence and
              serves on the Executive Committee of the Singapore Computer
              Society’s AI & Robotics Chapter.
              <br />
              <br />
              He holds a Doctorate and Bachelor’s degree in Engineering from
              NUS.
              <br />
              <br />
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
